import { BookOpen, CalendarClock, ClipboardList, Download, Flag, Gift, History, Image as ImageIcon, Lightbulb, Mail, Megaphone, Send, ShieldAlert, Tag, UserX, Users, Wallet, Wrench } from "lucide-react";

export const GROUPS = [
  { id: "families", label: "Families", Icon: Users, tabs: [["parents", "Parents & Children", Users], ["unpaid", "Unpaid", UserX], ["expiring", "Access ending", CalendarClock], ["gifts", "Year-end gift", Gift]] },
  { id: "money", label: "Payments", Icon: Wallet, tabs: [["billing", "Payment screenshots", Download], ["income", "Income", Wallet], ["promos", "Promo codes", Tag]] },
  { id: "messages", label: "Messages", Icon: Mail, tabs: [["survey-invites", "Send survey", Send], ["surveys", "Surveys", ClipboardList], ["offers", "Offers email", Megaphone], ["emails", "Emails", Mail]] },
  { id: "content", label: "Content", Icon: BookOpen, tabs: [["content", "Content tools", Wrench], ["reading", "Reading", BookOpen], ["pictures", "Pictures", ImageIcon], ["kreol", "Kreol hints", Lightbulb], ["reports", "Reports", Flag]] },
  { id: "log", label: "Activity", Icon: History, tabs: [["activity", "Activity", History], ["copy", "Copy attempts", ShieldAlert]] },
];

const groupOf = (tab) => GROUPS.find((g) => g.tabs.some(([id]) => id === tab)) || GROUPS[0];

export default function AdminTabs({ tab, onTab, counts = {} }) {
  const group = groupOf(tab);
  return (
    <div className="mb-6 space-y-3" data-testid="admin-tabs">
      <div className="flex flex-wrap gap-2 border-b border-slate-700 pb-3">
        {GROUPS.map(({ id, label, Icon, tabs }) => (
          <button key={id} onClick={() => onTab(tabs[0][0])} data-testid={`admin-group-${id}`}
            className={`px-4 py-2 rounded-xl text-sm font-bold inline-flex items-center gap-2 transition-colors ${group.id === id ? "bg-yellow-300 text-slate-900" : "bg-slate-800 text-slate-300 hover:bg-slate-700"}`}>
            <Icon size={16} /> {label}
          </button>
        ))}
      </div>
      {(
        <div className="flex flex-wrap gap-2" data-testid={`admin-subtabs-${group.id}`}>
          {group.tabs.map(([id, label, Icon]) => (
            <button key={id} onClick={() => onTab(id)} data-testid={`admin-tab-${id}`}
              className={`px-3 py-1.5 rounded-full border-2 text-sm font-semibold inline-flex items-center gap-1.5 ${tab === id ? "bg-white text-slate-900 border-white" : "border-slate-600 hover:border-slate-400"}`}>
              <Icon size={14} /> {label}{counts[id] !== undefined ? ` (${counts[id]})` : ""}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
